export const categories = {
    wellbeing: {
        name: 'Climat scolaire et bien-être',
        color: 'citoyennete',
        band: 'theme2'
    },
    citizenship: {
        name: 'Education à la citoyenneté',
        color: 'bientre',
        band: 'theme1'
    },
    other: {
        name: 'Autre',
        color: 'bientre',
        band: 'theme1'
    }
}

export const targets = {
    adults: 'Adultes',
    children: 'Enfants / ados'
}

export function prepareQuotationRequest(quotation: any) {
    return {
        ...quotation,
        '@type': 'QuotationRequestEducationCourse',
        prestations: quotation.prestations.map(prestation => ({
            ...prestation,
            educationCourse: prestation.educationCourse['@id']
        })),
        project: {
            ...quotation.project,
            '@type': 'ProjectEducationCourse',
            aroeven: quotation.project.aroeven['@id'],
            clients: [{
                ...quotation.project.client,
                aroeven: quotation.project.client.aroeven['@id'],
            }]
        }
    }
}